import React from "react";
import { useSettings } from "@/contexts/SettingsContext";
import { buildWhatsAppLink } from "@/lib/whatsapp";

export default function WhatsAppFloat() {
    const { settings } = useSettings();
    const link = buildWhatsAppLink(settings.whatsapp_number, "Hello Gold by SRN — I'd like to enquire about your collections.");

    return (
        <a
            data-testid="whatsapp-float"
            href={link}
            target="_blank"
            rel="noreferrer"
            aria-label="Chat on WhatsApp"
            className="fixed bottom-6 right-6 z-50 group"
        >
            <div className="w-14 h-14 rounded-full bg-[#25D366] flex items-center justify-center shadow-[0_8px_28px_-8px_rgba(37,211,102,0.55)] group-hover:scale-105 transition-transform">
                <svg viewBox="0 0 32 32" width="24" height="24" className="text-white" fill="currentColor">
                    <path d="M19.11 17.62c-.27-.14-1.6-.79-1.85-.88s-.43-.13-.61.13c-.18.27-.7.88-.86 1.06-.16.18-.32.2-.59.07-.27-.13-1.13-.42-2.16-1.34-.8-.71-1.34-1.59-1.5-1.86-.16-.27-.02-.41.12-.55.12-.12.27-.32.4-.48.13-.16.18-.27.27-.45.09-.18.05-.34-.02-.48-.07-.13-.61-1.47-.84-2.01-.22-.53-.45-.46-.61-.47-.16-.01-.34-.01-.52-.01-.18 0-.48.07-.73.34-.25.27-.96.94-.96 2.28s.98 2.64 1.12 2.82c.13.18 1.92 2.94 4.66 4.13.65.28 1.16.45 1.56.58.65.21 1.24.18 1.71.11.52-.08 1.6-.66 1.83-1.29.23-.63.23-1.17.16-1.29-.07-.12-.25-.18-.52-.32zM16.02 5.33c-5.92 0-10.74 4.82-10.74 10.74 0 1.9.5 3.74 1.45 5.38l-1.54 5.61 5.74-1.5a10.7 10.7 0 0 0 5.09 1.3h.01c5.92 0 10.74-4.82 10.74-10.74S21.94 5.33 16.02 5.33z" />
                </svg>
            </div>
        </a>
    );
}
